import { EditOutlined, SearchOutlined, PrinterOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Space,
  Table,
  Popconfirm,
  message,
  notification
} from "antd";


import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';



import { Link, useNavigate } from 'react-router-dom';
import commonUtility from "../../utility/Utils";
import { PRINT_BASE_URL } from "../../utility/URL";
import ProgrammeService from "../../api/programme.service";

import { SUCCESS_STATUS } from "../../utility/Constants";

// import CustomTableSearch from "../../common/CustomTableSearch";
// import commonUtility from "../../../utility/Utils";
// import { PRINT_BASE_URL } from "../../../utility/URL";
// import enrollmentService from "../../api/enrollment.service";




const AllReceiptView = (props) => {
  // console.log("reportlist", props.memberList)
  let navigate = useNavigate();
  const [form] = Form.useForm();

  const [getUserId, setGetUserId] = useState("");
  const [note, setNote] = useState('');

  useEffect(() => {
    if (props.memberList && props.memberList.length > 0) {
      setGetUserId(props.memberList[0].user_id); // Assuming you want the user_id of the first member
    }
  }, [props.memberList]);

  // const onReceiptDelete = (receiptId,notes) => {

  //   const data = { formdata: { receipt_id: receiptId,note:notes} };
  //   ProgrammeService.deleteReceipt(data).then((res) => {

  //     if(res.data.response_status == SUCCESS_STATUS) {      
  //       const updatedList = props.reportList.filter(item => item.receipt_id !== receiptId);
  //       props.setFilteredSearchList(updatedList);   
  //       commonUtility.openNotification("bottom", "Message", res.data.response_msg);
  //     }
  //     else{
  //       //message.error(res.response_msg);
  //       commonUtility.openNotification("bottom", "Message", res.data.response_msg);
  //     }
  //     togglePopconfirmVisible(receiptId)

  //   });  

  // }

  const [popconfirmVisibility, setPopconfirmVisibility] = useState(new Map());
  const [noteValues, setNoteValues] = useState(new Map());
  // Function to toggle the visibility of Popconfirm for a specific row
  // const togglePopconfirmVisible = (rowId) => {
  //   setPopconfirmVisibility(prevState => {
  //     const newState = new Map(prevState);
  //     newState.set(rowId, !newState.get(rowId)); // Toggle the visibility
  //     return newState;
  //   });
  // };

  // const handleNoteChange = (rowId, value) => {
  //   setNoteValues(prevState => {
  //     const newState = new Map(prevState);
  //     newState.set(rowId, value); // Update the note value
  //     return newState;
  //   });
  // };

  const togglePopconfirmVisible = (receiptId) => {
    setPopconfirmVisibility(prev => ({
      ...prev,
      [receiptId]: !prev[receiptId]
    }));
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  // InActive Button //

  // const handleConfirm = (receiptId) => {

  //   const data = { formdata: { receipt_id: receiptId, user_id: getUserId, note: note } };
  //   ProgrammeService.inActiveMemberAllReciept(data).then((res) => {

  //     if (res.data.response_status == SUCCESS_STATUS) {
  //       const updatedList = props.reportList.filter(item => item.receipt_id !== receiptId);
  //       props.setFilteredSearchList(updatedList);
  //       commonUtility.openNotification("bottom", "Message", res.data.response_msg);
  //     }
  //     else {
  //       commonUtility.openNotification("bottom", "Message", res.data.response_msg);
  //     }
  //     togglePopconfirmVisible(receiptId)
  //     setNote("")
  //   });
  // }

  const handleConfirm = (receiptId) => {
    form.validateFields().then(values => {
      const data = {
        formdata: {
          receipt_id: receiptId,
          user_id: getUserId,
          note: values[`inactive_note_${receiptId}`] || ""
        }
      };

      ProgrammeService.inActiveMemberAllReciept(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const updatedList = props.reportList.filter(item => item.receipt_id !== receiptId);
          props.setFilteredSearchList(updatedList);
          notification.success({
            message: 'Message',
            description: res.data.response_msg,
            placement: 'bottom'
          });
        } else {
          notification.error({
            message: 'Message',
            description: res.data.response_msg,
            placement: 'bottom'
          });
        }
        togglePopconfirmVisible(receiptId);
        form.resetFields();
      });
    }).catch(info => {
      console.log('Validate Failed:', info);
    });
  };

  const totalAmount = props.reportList.reduce(
    (sum, item) => sum + parseFloat(item.payment_amount || 0),
    0
  );

  const columns = [
    {
      title: 'Name',
      dataIndex: 'member_fname',
      key: 'member_fname',
      sorter: (a, b) => {
        const nameA = `${a.member_fname} ${a.member_lname}`;
        const nameB = `${b.member_fname} ${b.member_lname}`;
        return nameA.localeCompare(nameB);
      },
      render: (selectedObj, record) => (
        <Space>
          <span>{record.member_fname} {record.member_lname}</span>
        </Space>
      ),

    },
    {
      title: 'Program',
      dataIndex: 'programme_name',
      key: 'programme_name',

    },
    {
      title: 'Group/Shift',
      dataIndex: 'programme_group',
      key: 'programme_group',
    },
    {
      title: 'Payment No',
      dataIndex: 'payment_no',
      key: 'payment_no',

    },
    {
      title: 'Payment Date',
      dataIndex: 'payment_date',
      key: 'payment_date',
    },
    {
      title: 'Amount',
      dataIndex: 'payment_amount',
      key: 'payment_amount',
      align: 'right',
      render: (selectedObj, values) => (
        <div align="right">{commonUtility.sanitizeValue(values.payment_amount).toFixed(2)} </div>
      )
    },
    // {
    //   title: 'Action',
    //   key: 'action',
    //   render: (selectedObj) => (

    //     <Space style={{ display: 'flex', flexDirection: 'row' }}>

    //       {(selectedObj.entry_from == "A" && selectedObj.short_code == "TAP") && (
    //         // Render the first element if condition1 is true
    //         <a href={`${PRINT_BASE_URL}tap/tapreceipt/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`} target="_blank" rel="noopener noreferrer">
    //           <Button htmlType="button" size="small" shape="round" type="primary" ><PrinterOutlined /></Button>
    //         </a>
    //       )}

    //       {(selectedObj.entry_from == "B" && selectedObj.short_code == "TAP") && (
    //         // Render the first element if condition1 is true
    //         <a href={`${PRINT_BASE_URL}tap/printpdf/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} target="_blank" rel="noopener noreferrer">
    //           <Button htmlType="button" size="small" shape="round" type="primary" ><PrinterOutlined /></Button>
    //         </a>
    //       )}

    //       {(selectedObj.entry_from == "A" && selectedObj.short_code == "GYM") && (
    //         // Render the first element if condition1 is true
    //         <a href={`${PRINT_BASE_URL}tap/gymreceipt/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} target="_blank" rel="noopener noreferrer">
    //           <Button htmlType="button" size="small" shape="round" type="primary" ><PrinterOutlined /></Button>
    //         </a>
    //       )}

    //       {(selectedObj.short_code != "GYM" && selectedObj.short_code != "TAP" && selectedObj.entry_from != "G") && (
    //         // Render the first element if condition1 is true
    //         <a href={`${PRINT_BASE_URL}taxinvoice/receiptpdf/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`} target="_blank" rel="noopener noreferrer">
    //           <Button htmlType="button" size="small" shape="round" type="primary" ><PrinterOutlined /></Button>
    //         </a>
    //       )}

    //       {(selectedObj.entry_from == "G") && (
    //         // Render the first element if condition1 is true
    //         <a href={`${PRINT_BASE_URL}taxinvoice/generalreceiptprint/${selectedObj.receipt_id}/${selectedObj.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`} target="_blank" rel="noopener noreferrer">
    //           <Button htmlType="button" size="small" shape="round" type="primary" ><PrinterOutlined /></Button>
    //         </a>
    //       )}

    //       {/* {
    //          [1, 2].includes(commonUtility.getLoggedInUserInfo().user_role_id) ? (
    //       <Popconfirm
    //             title={
    //               <div style={{ width: '300px'}}>
    //                 <p>Are you sure you want to delete?</p>
    //                 <Form layout="vertical" form={form} onFinish={() => onReceiptDelete(selectedObj.receipt_id,noteValues.get(selectedObj.receipt_id))}>
    //                 <Form.Item
    //                   name={`delete_note_${selectedObj.receipt_id}`}
    //                   label="Note:"
    //                   rules={[
    //                     {
    //                       required: true,
    //                       message: 'Notes is required',
    //                     },
    //                     { min: 1, message: 'Notes must be at least 1 characters.' }
    //                   ]}
    //                   style={{marginBottom:'0px'}}
    //                 >
    //                   <Input.TextArea rows={2} onChange={(e) => handleNoteChange(selectedObj.receipt_id, e.target.value)}/>
    //                 </Form.Item>
    //                 </Form>
    //               </div>
    //             }
    //             icon={
    //               <QuestionCircleOutlined
    //                 style={{
    //                   color: 'red',
    //                 }}
    //               />
    //             }
    //             visible={popconfirmVisibility.get(selectedObj.receipt_id) || false}
    //             onConfirm={()=>{
    //              form.submit()
    //               // togglePopconfirmVisible(selectedObj.receipt_id);
    //             }}
    //             okText="Yes"
    //             cancelText="No"
    //             onCancel={() => {togglePopconfirmVisible(selectedObj.receipt_id)}}
    //           >
    //             {
    //               selectedObj.payment_id === selectedObj.max_payment_id && 
                
    //             <Button htmlType="button" type="danger" size="small" shape="round" onClick={() => togglePopconfirmVisible(selectedObj.receipt_id)}>
    //               <DeleteOutlined />
    //             </Button>
    //             }
    //           </Popconfirm>
    //          ) : null } */}

    //       <Popconfirm
    //         title={
    //           <div style={{ width: '300px' }}>
    //             <p>Are you sure you want to cancel?</p>
    //             <Form layout="vertical" form={form} onFinish={() => handleConfirm(selectedObj.receipt_id)}>
    //               <Form.Item
    //                 name={`inactive_note_${selectedObj.receipt_id}`}
    //                 label="Note:"
    //                 rules={[
    //                   {
    //                     required: true,
    //                     message: 'Notes is required',
    //                   },
    //                   { min: 1, message: 'Notes must be at least 1 character.' }
    //                 ]}
    //                 style={{ marginBottom: '0px' }}
    //               >
    //                 <Input.TextArea rows={2} onChange={handleNoteChange} />
    //               </Form.Item>
    //             </Form>
    //           </div>
    //         }
    //         icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
    //         visible={popconfirmVisibility[selectedObj.receipt_id] || false}
    //         onConfirm={() => form.submit()}
    //         okText="Yes"
    //         cancelText="No"
    //         onCancel={() => togglePopconfirmVisible(selectedObj.receipt_id)}
    //       >
    //         <Button htmlType="button" type="danger" size="small" shape="round" onClick={() => togglePopconfirmVisible(selectedObj.receipt_id)}>
    //           Cancel
    //         </Button>
    //       </Popconfirm>
    //     </Space>
    //   ),
    // },

  ];



  return (
    <>

      {/* <Form.Item name="search" >
        <Input placeholder="Search ..." size="large" onChange={(e) => onSearch(e)} prefix={<SearchOutlined />} allowClear className="table-search-box" />
      </Form.Item> */}
      {/* <CustomTableSearch onSearchTable={onSearch} style={{marginBottom: "8px"}} /> */}
      <Table
        columns={columns}
        rowKey="receipt_id"
        dataSource={props.reportList}
        size="small"
        pagination={{
          defaultPageSize: 1000,
          showSizeChanger: true,
          pageSizeOptions: ['100', '500', '1000', '2000']
        }}
        footer={() => (
          <div style={{ textAlign: "right", fontWeight: "bold" }}>
            Total Amount : ₹ {totalAmount.toFixed(2)}
          </div>
        )}
      />


    </>
  );
};

export default AllReceiptView;